import React from 'react';
import { Button, Checkbox, Modal, Spacing } from 'sugar-design';

import { LOCALES, getI18n } from '@/utils/i18n';

import styles from './index.cm.styl';

const i18n = getI18n();

interface UploadResumePromptModalProps {
  isOpen: boolean;
  isConfirmChecked: boolean;
  currentOrg: Record<string, unknown>;
  onCheckChange: (checked: boolean) => void;
  onClose: () => void;
  onConfirm: () => void;
}

const UploadResumePromptModal = (props: UploadResumePromptModalProps) => {
  const { isOpen, onCheckChange, isConfirmChecked, currentOrg = {}, onClose, onConfirm } = props;

  const { editingEditResumeTips, editingEditResumeEnTips } = currentOrg;

  const getDescription = () =>
    i18n.language === LOCALES.ZH_CN ? editingEditResumeTips : editingEditResumeEnTips;

  return (
    <Modal
      title={i18n.t`授权提示`}
      desc={
        <p className={styles.content}>
          {getDescription() || i18n.t`请确认本次简历上传已获得候选人授权`}
        </p>
      }
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      renderCustomFooter={({ onClose: _onClose, onConfirm: _onConfirm }) => (
        <Spacing stretched justify="between">
          <Checkbox
            checked={isConfirmChecked}
            onChange={(e) => onCheckChange(e.target.checked)}
          >{i18n.t`我已确认`}</Checkbox>
          <Spacing spacing={16}>
            <Button type="secondary" onClick={_onClose}>{i18n.t`取消`}</Button>
            <Button
              type="primary"
              onClick={_onConfirm}
              disabled={!isConfirmChecked}
            >{i18n.t`确认`}</Button>
          </Spacing>
        </Spacing>
      )}
    />
  );
};

export default UploadResumePromptModal;
